import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbOffcanvas, NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AcademicYearService } from '../../../../core/services/academic-year.service';
import { EducationalResourceService } from '../../../../core/services/educational-resource.service';
import { FileService } from '../../../../core/services/file.service';
import { PersonalContractService } from '../../../../core/services/personal-contract.service';
import { PersonalService } from '../../../../core/services/personal.service';
import { ProfessorAcademicClassroomService } from '../../../../core/services/professor-academic-classroom.service';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../core/utils/app-sweet-alert';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../components/loading/loading.component';
import { HeaderComponent } from '../../layout/includes/header/header.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'app-personal-contrat',
    templateUrl: './personal-contrat.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxExtendedPdfViewerModule, NgxPaginationModule],
    styleUrls: ['./personal-contrat.component.css']
})
export class PersonalContratComponent {
  @ViewChild('contentPDF') contentPDF:TemplateRef<any> | undefined
  @ViewChild('contentFiche') contentFiche:TemplateRef<any> | undefined
  pdfSrc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  pdfViewLoader=false
  vue="list"
  buttonsPermission :any|undefined;
 search_text=""
  personals:any[] =[]
  roles:any[] =[]
  data:any[] =[]
  ays:any[] =[]
  selected_data:any;
  modalOption:any; 
  fileInput:any; 
  classroomId:any
  ayId:any
  isDtInitialized:boolean = false
  is_active=null
  loading=false
  tag="professors-educational-resources"
  pg={
    pageSize:10,
    p:0,
    total:0
  }
  role:any
  user:any


  constructor(
    private personalContractService:PersonalContractService,
    private personalService:PersonalService,
    private spinnerService:NgxSpinnerService,
    private fileService:FileService,
    private toastrService:ToastrService,
    private offcanvasService: NgbOffcanvas,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }


  ngOnInit(): void {
    this.init()
    this.getActions()
  }

  init(){
    this.getAll()
    this.getPersonals()
  }

 


  getAll(){
    this.personalContractService.getAll().subscribe((res:any)=>{
      this.data=res.data
      this.modalService.dismissAll()
    },
    (err:any)=>{
    AppErrorShow.showError("Nos ressources pédagogiques",err)
    })
  }

  
  getPersonals(){
    this.personalService.getAll().subscribe((res:any)=>{
      this.personals=res.data
      this.modalService.dismissAll()
    },
    (err:any)=>{
      AppErrorShow.showError("Nos ressources pédagogiques",err)
    })
  }


  store(value:any){
    this.loading=true

    if (this.fileInput==undefined) {
      this.toastrService.warning('Le document est requis')

      return ;
    }

    let formData= new FormData()

    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        const element = value[key];
          formData.append(key,element)
      }
    }

    formData.append("contract_file",this.fileInput)

   
    
    this.personalContractService.store(formData).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.modalService.dismissAll()
        this.getAll()

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Nos ressources pédagogiques",err)

    })
  }
  update(value:any){
    this.loading=true

    this.personalContractService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Nos ressources pédagogiques",err)

    })
  }
  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.personalContractService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Nos ressources pédagogiques",err)

    })
  }
})
  }
  checked(el?:any){
    this.selected_data=el;
    this.is_active=el.is_active
  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }



  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }


  show(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalOption={centered:false,size:"lg"}
    this.modalService.open(content,{size:'lg'});
  }

  edit(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalService.open(content,{size:'lg'});

  }

  setStatus(value:any){

    this.toastrService.warning("Opération en cours")
  
        this.personalContractService.setState(this.selected_data.id,value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
      },
      (err:any)=>{
        console.log(err)
          AppErrorShow.showError("Nos ressources pédagogiques",err)

      })
  }

  getActions(){
    // this.buttonsPermission = {
    //   show:AppActionCheck.check(this.tag,'Consultation'),
    //   add:AppActionCheck.check(this.tag,'ajout'),
    //   edit:AppActionCheck.check(this.tag,'edition'),
    //   delete:AppActionCheck.check(this.tag,'suppression'),
    //   status:AppActionCheck.check(this.tag,'statut')
    // };
    this.buttonsPermission={
      show:false,
      add:true,
      edit:true,
      delete:true,
      status:true,
    }
  }



  changeView(event:any){
    this.vue=event.target.value
  }

  upload(ev:any){
    if (ev.target.files.length!=0) {
      this.fileInput=ev.target.files[0]
    }
  }

  getFile(el:any){
    let css='details-panel'
    this.pdfViewLoader=true
    this.spinnerService.show()
    this.fileService.get2({path:`personal_contracts/${el.contract_file}`}).subscribe((res:any)=>{
      this.spinnerService.hide()
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: css, position: 'end'  });
    },
    (err:any)=>{
      this.spinnerService.hide()
      AppErrorShow.showError("Gestion des utilisateurs",err)

    })
  }

  getPage(event:any){
    this.pg.p=event
  }
}
